import React, { useState } from 'react';
import { Loader2, Save, X } from 'lucide-react';

const STATUTS = [
  { v: 'brouillon', label: 'Brouillon' },
  { v: 'publie', label: 'Publié' },
  { v: 'termine', label: 'Terminée' },
];

const Field = ({ label, children }) => (
  <div><label className="text-sm font-800 mb-1.5 block">{label}</label>{children}</div>
);
const inputCls = 'w-full px-4 py-2.5 rounded-xl bg-muted outline-none focus:ring-2 focus:ring-primary/40 font-600';

const SeriesForm = ({ initial, onSubmit, onCancel }) => {
  const [f, setF] = useState({
    titre: '', slug: '', auteur: '', resume: '', couverture_url: '', collection: '',
    statut: 'brouillon', ordre_affichage: 0, date_publication: '', ...(initial || {}),
  });
  const [busy, setBusy] = useState(false);
  const upd = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await onSubmit({ ...f, ordre_affichage: parseInt(f.ordre_affichage) || 0 }); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="bg-card border border-border rounded-2xl p-5 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-display font-700 text-lg">{initial ? 'Modifier la série' : 'Nouvelle série'}</h3>
        <button type="button" onClick={onCancel} className="w-8 h-8 rounded-full bg-muted flex items-center justify-center"><X className="w-4 h-4" /></button>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="Titre *"><input required value={f.titre} onChange={upd('titre')} className={inputCls} placeholder="Titre de la série" /></Field>
        <Field label="Slug (auto si vide)"><input value={f.slug} onChange={upd('slug')} className={inputCls} placeholder="mon-slug" /></Field>
        <Field label="Auteur"><input value={f.auteur} onChange={upd('auteur')} className={inputCls} /></Field>
        <Field label="Collection"><input value={f.collection} onChange={upd('collection')} className={inputCls} placeholder="escapades-atlantiques" /></Field>
      </div>
      <Field label="Résumé"><textarea rows={3} value={f.resume} onChange={upd('resume')} className={`${inputCls} resize-none`} /></Field>
      <Field label="URL de couverture"><input value={f.couverture_url} onChange={upd('couverture_url')} className={inputCls} placeholder="https://..." /></Field>
      <div className="grid sm:grid-cols-3 gap-4">
        <Field label="Statut"><select value={f.statut} onChange={upd('statut')} className={`${inputCls} cursor-pointer`}>{STATUTS.map((s) => <option key={s.v} value={s.v}>{s.label}</option>)}</select></Field>
        <Field label="Ordre d'affichage"><input type="number" value={f.ordre_affichage} onChange={upd('ordre_affichage')} className={inputCls} /></Field>
        <Field label="Date de publication"><input type="date" value={f.date_publication} onChange={upd('date_publication')} className={inputCls} /></Field>
      </div>
      {f.couverture_url && <img src={f.couverture_url} alt="aperçu" className="w-32 h-20 object-cover rounded-lg" />}
      <button type="submit" disabled={busy} className="flex items-center gap-2 px-6 py-3 rounded-full bg-primary text-white font-800 hover:scale-[1.02] transition-transform disabled:opacity-60">
        {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Save className="w-5 h-5" />} Enregistrer
      </button>
    </form>
  );
};

export default SeriesForm;
